export default {"src":"/evde-internet/_next/static/media/star.40a30cf0.svg","height":24,"width":24};